import { createSelector } from "@reduxjs/toolkit";

export const applicationSelector = createSelector(
	({ app }) => app.trackingUrl,
	({ app }) => app.trackingId,
	({ app }) => app.environment,
	({ app }) => app.statusCode,
	({ app }) => app.error,
	(trackingUrl, trackingId, environment, statusCode, errorMessage) => ({
		trackingPixelUrl: `${trackingUrl}/imageVerifyVisit?a=${trackingId}`,
		environment,
		statusCode,
		errorMessage
	})
);

export default applicationSelector;
